import { IonCard, IonCardContent, IonCol, IonRow, useIonToast } from "@ionic/react";
import {
  atOutline,
  cardOutline,
  chatboxOutline,
  ellipsisHorizontalOutline,
  leafOutline,
  personOutline,
  phonePortraitOutline
} from "ionicons/icons";
import { useContext, useEffect, useState } from "react";
import ActionButton from "../../components/button/ActionButton";
import CheckBoxItem from "../../components/checkbox/CheckBoxItem";

import { useLocation } from "react-router-dom";
import InputItem from "../../components/input/InputItem";
import RadioItem from "../../components/radio/RadioItem";
import SlideContent from "../../components/slide-content/SlideContent";
import Templates from "../../components/templates/Template";
import { AuthContext } from "../../context/AuthContext";
import { DataProvider } from "../../library/DataProvider";
import { passToWebView } from "../../library/Funcs";
import { DonationPostAction } from "../../redux/actions/Donation";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

import './Online.css'

interface Props {
  campaign_id: string;
  pay_do: string;
  isPlanting?: boolean;
  seedlings?: any;
  templates?: any;
  treePlateAmount?: number;
  treePlateDescription?: string;
}

const Online: React.FC<Props> = (props) => {
  const [toast, dismiss] = useIonToast();
  const dispatch = useAppDispatch();
  const authContext = useContext(AuthContext);
  const [seedling, setSeedling] = useState(0);
  const [templateId, setTemplateId] = useState(0);
  const formDonation = useAppSelector((state) => state.donationPost);
  const { form_loading, resp } = formDonation;
  const [platePrice, setPlatePrice] = useState(0);

  const [form, setForm] = useState({
    amount: {
      value: "",
      validation: { min_amount: window.initials?.donation_min !== undefined ? window.initials?.donation_min : 100000, required: true },
      error: "",
    },
    full_name: { value: "", validation: {}, error: "" },
    mobile: { value: "", validation: { min: 11, max: 11, required: authContext.auth ? false : true }, error: "" },
    gift_name: { value: "", validation: {}, error: "" },
    gift_mobile: { value: "", validation: {}, error: "" },
    doc_name: { value: "", validation: {}, error: "" },
    doc_memorial: { value: "", validation: {}, error: "" },
    doc_template: { value: "", validation: {}, error: "" },
    install_plate: { value: false, validation: {}, error: "" },
    comment: { value: "", validation: {}, error: "" },
    anonymous: { value: false, validation: {}, error: "", disabled: false },
    anonymous_price: { value: false, validation: {}, error: "", disabled: false },
    anonymous_profile: { value: false, validation: {}, error: "", disabled: false },
    seedling_type: { value: "", label: "", amount: 0, validation: props.isPlanting ? { required: true } : { required: false }, error: "" },
  });

  const [formProvider] = useState(() => new DataProvider(form, setForm));

  useEffect(() => {
    if (props.seedlings != null) {
      var f = { ...form };
      f.seedling_type.label = props.seedlings[0].type;
      f.seedling_type.value = props.seedlings[0].id;
      f.seedling_type.amount = props.seedlings[0].price;
      setForm(f);
    }
  }, [props.seedlings]);

  useEffect(() => {
    var f = { ...form };
    if (form.install_plate.value) {
      setPlatePrice(parseFloat(f.amount.value.length == 0 ? '0' : f.amount.value) + (props.treePlateAmount ?? 0));
    } else {
      setPlatePrice(parseFloat(f.amount.value.length == 0 ? '0' : f.amount.value) - (props.treePlateAmount ?? 0));
    }
    setForm(f);
  }, [form.install_plate.value])

  useEffect(() => {
    var f = { ...form };
    f.mobile.validation.required = !authContext.auth;
    setForm(f);
  }, [authContext.auth]);

  const formSubmitHandler = (e: any) => {
    e.preventDefault();

    let formValidation = formProvider.validation(form);

    if (formValidation) {
      if (!authContext.auth) {
        if (form.gift_mobile.value != "" && form.full_name.value == "") {
          toast({ message: "جهت اهدای حمایت ورود نام شما الزامی است.", duration: 3000, color: "warning" });
          return;
        }
      }

      if (form.gift_mobile.value != "" && form.gift_name.value == "") {
        toast({ message: "جهت اهدای حمایت ورود نام هدیه گیرنده الزامی است.", duration: 3000, color: "warning" });
        return;
      }

      // if (form.gift_name.value != "" && form.gift_mobile.value == "") {
      //   toast({ message: "جهت اهدای حمایت ورود تلفن همراه هدیه گیرنده الزامی است.", duration: 3000, color: "warning" });
      //   return;
      // }

      if (props.isPlanting) {
        if (form.gift_mobile.value != "" && form.doc_name.value == "") {
          toast({ message: "جهت اهدای سند هدیه درخت فیلد «نام اهدا کننده / از طرف» باید تکمیل شود.", duration: 4000, color: "warning" });
          return;
        } else if (form.install_plate && (form.gift_name.value == "" || form.doc_name.value == "")) {
          toast({ message: "جهت نصب پلاک بر روی نهال، نام اهداکننده و هدیه گیرنده را تکمیل کنید.", duration: 4000, color: "warning" });
          return;
        }
      }

      dispatch(
        DonationPostAction(
          props.campaign_id,
          "0",
          form.amount.value.replace(/\D+/g, ""),
          form.full_name.value,
          form.mobile.value,
          props.pay_do,
          form.doc_name.value,
          form.doc_memorial.value,
          templateId.toString(),
          form.gift_name.value,
          form.gift_mobile.value,
          form.comment.value,
          form.anonymous.value,
          form.anonymous_price.value,
          form.anonymous_profile.value,
          form.seedling_type.value,
          form.install_plate.value,
        )
      );
    }
  };

  useEffect(() => {
    const formDone = () => {
      if (resp != null && !form_loading) {
        if (resp.result) {
          passToWebView("sendPayment", resp.url);
          formProvider.reset();
        } else {
          toast({ message: resp.message, duration: 2000, color: "danger" });
        }
      }
    };

    formDone();
  }, [form_loading]);

  const checkAnonymous = (e: any) => {
    var f = { ...form };

    if (formProvider.form.anonymous.value) {
      f.anonymous_price.disabled = true;
      f.anonymous_price.value = false;

      f.anonymous_profile.disabled = true;
      f.anonymous_profile.value = true;
    } else {
      f.anonymous_price.disabled = false;
      f.anonymous_price.value = false;

      f.anonymous_profile.disabled = false;
      f.anonymous_profile.value = false;
    }

    setForm(f);
  };

  const seedlingTypeChangeHanlder = (e: any) => {
    if (e.target.value == undefined) return;

    let price = 0;
    for (let i = 0; i < props.seedlings?.length; i++) {
      const el = props.seedlings[i];

      if (el.id == form.seedling_type.value) {
        price = el.price;
        break;
      }
    }

    price = price * seedling;

    var f = { ...form };
    if (price == 0) f.amount.value = "";
    else f.amount.value = price.toString();
    setForm(f);
  };

  const seedlingCountChangeHanlder = (e: any) => {
    if (e.target.value === undefined) return;

    const count = e.target.value;
    setSeedling(count);

    let price = 0;
    for (let i = 0; i < props.seedlings?.length; i++) {
      const el = props.seedlings[i];

      if (el.id == form.seedling_type.value) {
        price = el.price;
        break;
      }
    }

    price = price * count;

    var f = { ...form };
    if (price == 0) f.amount.value = "";
    else f.amount.value = price.toString();
    setForm(f);
  };

  const getSelectedSeedling = () => {
    if (!props.seedlings || !form.seedling_type.value) return null;

    const seeling = props.seedlings.find((item: any) => String(item.id) === String(form.seedling_type.value)) ?? null;
    if (seedling != null)
      return 'هزینه 1 نهال ' + (seeling.price / 10000).toString() + ' هزار تومان';
  };

  const getSeelings = () => {
    return Math.floor(parseFloat(form.amount.value) / form.seedling_type.amount);
  }

  return (
    <SlideContent type="segment">
      <IonCard>
        <IonCardContent className="donation-online">
          <form onSubmit={formSubmitHandler}>
            {props.isPlanting ? (
              <>
                <IonRow className="tree-options-container">
                  <IonCol size="7">
                    <InputItem name="seedling_type" type="select2" label="نوع نهال" icon={leafOutline} provider={formProvider} change={seedlingTypeChangeHanlder}>
                      {props.seedlings?.map((item: any) => {
                        return <RadioItem value={item["id"]} label={item["type"]} />;
                      })}
                    </InputItem>
                  </IonCol>
                  <IonCol size="5">
                    <InputItem
                      name="seedling_count"
                      type="number"
                      label="تعداد نهال"
                      value={seedling}
                      change={seedlingCountChangeHanlder}
                      icon={ellipsisHorizontalOutline}
                      maxlength={5}
                      ltr
                      spaced
                    />
                  </IonCol>
                </IonRow>

                <InputItem name="amount" type="number" label="مبلغ حمایت (ریال)" sublabel={getSelectedSeedling()} icon={cardOutline} maxlength={13} ltr spaced provider={formProvider} />

                {form.amount.value.length > 0 ?
                  <div className="total-amount">
                    <p><small>تعداد نهال شما</small><span>{getSeelings()} نهال</span></p>
                    {form.install_plate.value && <p><small>مبلغ پلاک</small><span>{(props.treePlateAmount! * getSeelings()).toThousandSep()} ریال</span></p>}
                    <p><small>مبلغ کل</small><span>{(parseFloat(form.amount.value) + (form.install_plate.value ? props.treePlateAmount! * getSeelings() : 0)).toThousandSep()} ریال</span></p>
                  </div>
                  : null}
              </>
            ) : (
              <InputItem name="amount" type="number" label="مبلغ حمایت (ریال)" icon={cardOutline} maxlength={13} ltr spaced provider={formProvider} />
            )}

            <AuthContext.Consumer>
              {(context) => {
                return !context.auth ? (
                  <>
                    <InputItem name="mobile" type="tel" label="تلفن همراه شما" icon={phonePortraitOutline} maxlength={11} ltr provider={formProvider} />
                  </>
                ) : null;
              }}
            </AuthContext.Consumer>

            <h3 className="head-text">تکمیل موارد زیر اختیاری است.</h3>

            <div className="optional-container">
              <AuthContext.Consumer>
                {(context) => {
                  return !context.auth ? (
                    <>
                      <InputItem name="full_name" type="text" label="نام شما" icon={personOutline} maxlength={50} provider={formProvider} />
                    </>
                  ) : null;
                }}
              </AuthContext.Consumer>

              {props.isPlanting ? (
                <>
                  <p className="note-text">
                    جهت دریافت سند درخت، <strong>نام اهداکننده</strong> و <strong>متن یادبود</strong> را تکمیل کنید. چنانچه مبلغ پرداختی شما حداقل به مقدار 1
                    نهال باشد امکان دریافت سند را پس از پرداخت خواهید داشت.
                  </p>

                  <p className="note-text-danger">از درج ایموجی و شکلک ها در قسمت های نام اهداکننده، متن یادبود و نام نهال خودداری کنید.</p>

                  <InputItem name="doc_name" type="text" label="نام اهدا کننده / از طرف" icon={personOutline} maxlength={50} provider={formProvider} />

                  <InputItem
                    name="doc_memorial"
                    type="text"
                    label="متن یادبود (زیر سند درج می شود)"
                    icon={phonePortraitOutline}
                    maxlength={110}
                    provider={formProvider}
                  />
                </>
              ) : null}

              <>
                {props.isPlanting ? (
                  <div>
                    <p className="note-text">
                      اگر قصد دارید سند درخت را به شخصی هدیه کنید <strong>نام نهال</strong> و <strong>تلفن همراه</strong> هدیه گیرنده را تکمیل کنید. پس از پرداخت
                      موفق یک پیامک حاوی لینک سند درخت برایشان ارسال خواهد شد.
                    </p>
                  </div>
                ) : (
                  <p className="note-text">
                    شما میتوانید این حمایت را به یکی از دوستان خود اهدا نمائید. برای این کار نام و شماره همراه ایشان را وارد کنید. پس از پرداخت موفق یک پیامک
                    حاوی لینک کارت هدیه برایشان ارسال خواهد شد.
                  </p>
                )}

                {props.isPlanting ? (
                  <InputItem
                    name="gift_name"
                    type="text"
                    label="نام نهال (نام مرحوم یا هدیه گیرنده)"
                    icon={personOutline}
                    maxlength={50}
                    provider={formProvider}
                  />
                ) : (
                  <InputItem name="gift_name" type="text" label="نام هدیه گیرنده" icon={personOutline} maxlength={50} provider={formProvider} />
                )}

                <InputItem
                  name="gift_mobile"
                  type="tel"
                  label="تلفن همراه هدیه گیرنده"
                  icon={phonePortraitOutline}
                  maxlength={11}
                  ltr
                  provider={formProvider}
                />

                {<Templates type={props.isPlanting ? 'tree' : 'gift'} templates={props.templates} templateId={templateId} setTemplateId={setTemplateId} donator={form.doc_name.value} giftName={form.gift_name.value} memorial={form.doc_memorial.value} />}
              </>

              {props.isPlanting &&
                <div className="tree_plate_container">
                  <CheckBoxItem
                    name="install_plate"
                    key="install_plate"
                    label="آیا مایل به نصب پلاک روی نهال و دریافت عکس آن هستید؟"
                    provider={formProvider} />
                  <div className={"tree_plate_description " + (form.install_plate.value ? "" : "ion-hide")} >
                    <div dangerouslySetInnerHTML={{ __html: props.treePlateDescription! }}></div>
                  </div>
                </div>
              }

              <InputItem
                name="comment"
                type="textarea"
                label="نظر شما (در بخش دیدگاه برای عموم نمایش داده می شود.)"
                icon={chatboxOutline}
                maxlength={1000}
                rows={2}
                provider={formProvider}
              />

              <CheckBoxItem name="anonymous" key="anonymous" label="حمایت به صورت ناشناس" provider={formProvider} click={(e: any) => checkAnonymous(e)} />

              <CheckBoxItem
                name="anonymous_price"
                key="anonymous_price"
                label="عدم نمایش مبلغ"
                disabled={form.anonymous_price.disabled}
                provider={formProvider}
              />

              <CheckBoxItem
                name="anonymous_profile"
                key="anonymous_profile"
                label="عدم نمایش تصویر پروفایل"
                disabled={form.anonymous_profile.disabled}
                provider={formProvider}
              />
            </div>

            <ActionButton text="ورود به صفحه پرداخت بانک" loading={form_loading} />
          </form>
        </IonCardContent>
      </IonCard>
    </SlideContent>
  );
};

export default Online;
